import React from 'react';

const PanelBreadcrumbs = ({ current, setActivePage }) => {
  return (
    <nav className="mb-3" aria-label="Breadcrumb">
      <ol className="flex items-center gap-2 text-xs text-gray-500">
        <li>
          {typeof setActivePage === 'function' ? (
            <button
              onClick={() => setActivePage('dashboard')}
              className="hover:text-gray-800 transition-colors"
              title="Go to Dashboard"
            >
              Dashboard
            </button>
          ) : (
            <span>Dashboard</span>
          )}
        </li>
        <li className="text-gray-300">/</li>
        <li className="text-gray-800 font-medium">{current}</li>
      </ol>
    </nav>
  );
};

export default PanelBreadcrumbs;

